/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Narrows the diff to a single tile — flat because a tile is clicked as a whole, so dropped splits into its three reasons here. all (default) does not narrow.
 */
export enum SurveyReplacementReviewDiffRowStatusFilter {
    ALL = 'all',
    REPLACED = 'replaced',
    NO_CHANGES = 'noChanges',
    NEW_MAPPING = 'newMapping',
    DROPPED_NO_CUT = 'droppedNoCut',
    DROPPED_NO_MAPPING_OR_CUT = 'droppedNoMappingOrCut',
    DROPPED_NO_DATA_BEHIND_CUT = 'droppedNoDataBehindCut',
}
